<div class="flex flex-1 flex-row">
	<div class="w-1/2">
		<h2>Property taxes</h2>
		<div class="mr-5 mt-5">
			<app-select
				label="Tax bill"
				[(ngModel)]="adjustment.taxBill"
				(ngModelChange)="changed()"
			>
				<option value="final">Final bill</option>
				<option value="previous">Previous year's</option>
				<option value="interim">Interim bill</option>
				<option value="estimated">Estimated final</option>
				<option value="na">Not assessed</option>
			</app-select>
			<div *ngIf="adjustment.taxBill !== 'na'">
				<app-input
					label="Adjustment title"
					[(ngModel)]="adjustment.title"
					class="mt-3"
				></app-input>

				<app-input
					type="cents"
					[label]="totalLabel"
					name="total"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[(ngModel)]="adjustment.total"
					(ngModelChange)="changed()"
				></app-input>
				<app-input
					type="number"
					*ngIf="adjustment.taxBill === 'interim'"
					label="Interim portion of the total"
					name="interim"
					class="mt-3"
					[startIcon]="ICON.PERCENTAGE"
					[(ngModel)]="adjustment.interim"
					(ngModelChange)="changed()"
				></app-input>
				<app-input
					type="number"
					*ngIf="
						adjustment.taxBill === 'previous' ||
						adjustment.taxBill === 'interim'
					"
					label="Estimated increase"
					name="increase"
					class="mt-3"
					[startIcon]="ICON.PERCENTAGE"
					[(ngModel)]="adjustment.increase"
					(ngModelChange)="changed()"
					step="0.1"
				></app-input>
				<app-input
					type="cents"
					*ngIf="
						adjustment.taxBill === 'previous' ||
						adjustment.taxBill === 'interim'
					"
					[label]="estimatedLabel"
					name="increase"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[ngModel]="estimatedIncrease"
					[disabled]="true"
				></app-input>
				<app-input
					type="cents"
					[label]="vendorShareLabel"
					name="vendorShare"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[ngModel]="vendorShare"
					[disabled]="true"
				></app-input>
				<app-radio-group
					class="mt-3"
					[items]="vendorPaidItems"
					label="Vendor will have paid full amount"
					name="vendorPaid"
					[(ngModel)]="adjustment.vendorPaid"
					(ngModelChange)="changed(true)"
					type="compact"
				></app-radio-group>
				<app-input
					type="cents"
					[label]="vendorPaidLabel"
					name="vendorPaidAmount"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[(ngModel)]="adjustment.vendorPaidAmount"
					(ngModelChange)="changed()"
					[disabled]="adjustment.vendorPaid === 'yes'"
				></app-input>
				<app-input
					*ngIf="creditAmount >= 0"
					type="cents"
					label="Credit vendor"
					name="credit"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[ngModel]="creditAmount"
					[disabled]="true"
				></app-input>
				<app-input
					*ngIf="creditAmount < 0"
					type="cents"
					label="Credit purchaser"
					name="credit"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[ngModel]="creditAmount * -1"
					[disabled]="true"
				></app-input>
			</div>
			<div class="mt-3">
				<app-checkbox
					label="Include all details in document"
					[(ngModel)]="adjustment.details"
				></app-checkbox>
			</div>
		</div>
		<div class="flex justify-between mr-5 mt-5">
			<app-button
				btn="tertiary"
				class="mr-5"
				size="small"
				(click)="cancelModal()"
				>Cancel</app-button
			>
			<app-button (click)="saveModal()" size="small">Save</app-button>
		</div>
	</div>
	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div class="mb-3" *ngIf="adjustment.taxBill === 'na'">
					<div class="mb-3">Not assessed</div>
					<div>No adjustment</div>
				</div>
				<div *ngIf="adjustment.taxBill !== 'na'">
					<div class="mb-8">
						<div class="flex justify-between items-start mb-3">
							<div *ngIf="adjustment.taxBill === 'final'">
								{{ currentYear }} total taxes
							</div>
							<div *ngIf="adjustment.taxBill === 'previous'">
								{{ currentYear - 1 }} total taxes
							</div>
							<div *ngIf="adjustment.taxBill === 'interim'">
								{{ currentYear }} interim taxes
							</div>
							<div *ngIf="adjustment.taxBill === 'estimated'">
								{{ currentYear }} estimated total taxes
							</div>
							<div>{{ adjustment.total | centsToDollars }}</div>
						</div>
						<div
							*ngIf="
								adjustment.taxBill === 'previous' ||
								adjustment.taxBill === 'interim'
							"
							class="flex justify-between items-start mb-3"
						>
							<div>Estimated increase for {{ currentYear }}</div>
							<div>{{ adjustment.increase / 100 | percent: '1.0-4' }}</div>
						</div>
						<div
							*ngIf="
								adjustment.taxBill === 'previous' ||
								adjustment.taxBill === 'interim'
							"
							class="flex justify-between items-start mb-3"
						>
							<div>Estimated total for {{ currentYear }} taxes</div>
							<div>{{ estimatedIncrease | centsToDollars }}</div>
						</div>
					</div>
					<div class="flex justify-between items-start mb-3">
						<div>Vendor's share for {{ dayOfYear }} days</div>
						<div>{{ vendorShare | centsToDollars }}</div>
					</div>
					<div class="flex justify-between items-start mb-3">
						<div>Vendor has paid</div>
						<div>{{ adjustment.vendorPaidAmount | centsToDollars }}</div>
					</div>
					<div class="flex justify-end items-start mb-3">
						<div *ngIf="creditAmount >= 0">
							<strong
								>Credit Vendor = {{ creditAmount | centsToDollars }}</strong
							>
						</div>
						<div *ngIf="creditAmount < 0">
							<strong
								>Credit Purchaser =
								{{ creditAmount * -1 | centsToDollars }}</strong
							>
						</div>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
